import dispatcher from "../Dispatcher/Dispatcher";
import config from "../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import tabsConstants from "../Constants/TabsConstants";
import printJS from "print-js";

class TabsActions {
  getDocuments(anlageid) {
    httpRequest(
      config.webServiceURL + "/document/documents?anlageId=" + anlageid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_DOCUMENTS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_DOCUMENTS_SUCCESS,
            result: null,
          });
        }
      }
    );
  }

  getAnlageBild(anlageid) {
    httpRequest(
      config.webServiceURL + "/document/anlageBild?anlageId=" + anlageid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_BILD_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_BILD_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  betriebsanleitungGenerieren(anlageid, mitabnahmeprotokoll) {
    httpRequest(
      config.webServiceURL +
        "/anlage/Generatebetriebsanleitung?anlageid=" +
        anlageid +
        "&mitAbnahmeprotokoll=" +
        mitabnahmeprotokoll,
      "POST",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GENERIERT_BETR_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GENERIERT_BETR_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  getDocumentAsByte(documentId, documentName) {
    httpRequest(
      config.webServiceURL + "/document/OpenDocument/" + documentId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          const url = window.URL.createObjectURL(res);
          let a = document.createElement("a");

          a.href = url;
          //a.target="_blank" ;
          a.download = documentName;

          let str = documentId.toString().toLowerCase();
          if (str === "abnahmeprotokoll.pdf") {
            printJS(url);
          } else {
            //a.target="_blank";
            a.click();
          }

          window.URL.revokeObjectURL(url);

          dispatcher.dispatch({
            type: tabsConstants.GET_DOCUMENTASBYTE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_DOCUMENTASBYTE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  CheckIfFileExists(path) {
    httpRequest(
      config.webServiceURL + "/document/FileExists?path=" + path,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.CHECK_FILEEXISTS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.CHECK_FILEEXISTS_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  deleteDocument(documentId) {
    httpRequest(
      config.webServiceURL + "/document/deletedocument/" + documentId,
      "DELETE",
      null,
      // JSON.stringify(documentId),
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.DELETE_DOCUMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.DELETE_DOCUMENT_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  getEquiDetails(anlageid) {
    httpRequest(
      config.webServiceURL + "/Anlage/Anlagedetails?id=" + anlageid,
      "GET",
      null,
      (res, msg) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_EQUIPMENTDETAIL_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_EQUIPMENTDETAIL_FAILURE,
            result: msg,
          });
        }
      }
    );
  }

  getEquipmentOverviewDetails(anlageid) {
    httpRequest(
      config.webServiceURL + "/Anlage/GetEquipmentDetail?id=" + anlageid,
      "GET",
      null,
      (res, msg) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_EQUIP_DETAIL_OVERVIEW_FAILURE,
            result: msg,
          });
        }
      }
    );
  }

  getAuftragDetails(anlageid, status, pageSize) {
    httpRequest(
      config.webServiceURL +
        "/AuftragManagement/GetAnlageAuftraege/" +
        anlageid +
        "/" +
        status +
        "/" +
        pageSize,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_AUFTRAGSDETAIL_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_AUFTRAGSDETAIL_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  addDocument(documents) {
    httpRequest(
      config.webServiceURL + "/document/createdocuments",
      "POST",
      JSON.stringify(documents),
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.ADD_DOCUMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.ADD_DOCUMENT_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  pruefberichtGenerieren(auftragid) {
    httpRequest(
      config.webServiceURL +
        "/AuftragManagement/GeneratePruefbericht?auftragid=" +
        auftragid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GENERIERT_PRUEFBERICHT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GENERIERT_PRUEFBERICHT_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  getInspectionImage(anlageid) {
    httpRequest(
      config.webServiceURL + "/document/GetAnlageAuftragBild/" + anlageid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_INSPECTION_IMAGE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_INSPECTION_IMAGE_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  getAuftragStatus() {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/GetAuftragStatuses/",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_ORDER_STATUS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_ORDER_STATUS_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  getAcceptanceProtocol(anlageid, mitabnahmeprotokoll) {
    httpRequest(
      config.webServiceURL +
        "/anlage/GenerateManualWithAcceptanceProtocol?anlageid=" +
        anlageid +
        "&mitAbnahmeprotokoll=" +
        mitabnahmeprotokoll,
      "POST",
      null,
      (res) => {
        if (res !== "Error") {
          const url = window.URL.createObjectURL(res);
          let a = document.createElement("a");
          a.href = url;
          // a.download = documentName;
          printJS(url);
          window.URL.revokeObjectURL(url);
          dispatcher.dispatch({
            type: tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GENERATE_ACCEPTANCE_PROTOCOL_FAILURE,
            result: null,
          });
        }
      }
    );
  }

  getAuftragDetailsByAuftrageId(auftragId) {
    httpRequest(
      config.webServiceURL + "/AuftragManagement/GetAuftragDetail/" + auftragId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: tabsConstants.GET_AUFTRAGSDETAILBYID_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: tabsConstants.GET_AUFTRAGSDETAILBYID_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}
export default new TabsActions();
